var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"MainDialog"}},[_c('div',{staticClass:"dialog_box",attrs:{"data-dialog-box":""}},[_c('p',{staticClass:"title"},[_vm._v("訊息")]),_c('div',{staticClass:"content",domProps:{"innerHTML":_vm._s(_vm.dialogContent)}}),_c('div',{staticClass:"button_box"},[_c('button',{on:{"click":function($event){return _vm.$store.commit('setDialog', {
            status: false,
            content: _vm.dialogContent,
          })}}},[_vm._v(" 關閉 ")])])]),_c('div',{staticClass:"background_box",attrs:{"data-dialog-background":""}})])
}
var staticRenderFns = []

export { render, staticRenderFns }